import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Preferences } from '../../../common/Preferences';
import { OuterContainer } from '../DashboardOuterContainerPagesLayout';

export default function AccountPreferences() {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <OuterContainer
      sx={{
        padding: theme.spacing(0),
        pr: `${theme.spacing(2)} !important`,
        paddingTop: theme.spacing(4),
      }}
    >
      <>
        <Typography
          variant="h12"
          sx={{ marginBottom: theme.spacing(1) }}
        >
          {t('navigation.preferences')}
        </Typography>
        <Preferences />
      </>
    </OuterContainer>
  );
}
